import React, { PureComponent } from "react";
import PhoneInput from "../../Common/PhoneInput";
import SmsVerification from "../../../routes/screens/Users/Profile/SmsVerification";

export default class EditInput extends PureComponent {
  state = {
    firstName: this.props.defaultFirstName,
    lastName: this.props.defaultLastName,
    email: this.props.defaultEmail,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    mobileNumber: this.props.defaultMobileNumber
  };
  handleChange = event => {
    const { target, preventDefault } = event;
    const newEvent = { target, preventDefault };
    this.setState(
      {
        [event.target.id]: event.target.value
      },
      () => {
        const {
          defaultFirstName,
          defaultLastName,
          defaultEmail,
          inputName,
          onChange,
          handleChangePassword
        } = this.props;
        const { firstName, lastName, email } = this.state;
        if (inputName === "name") {
          if (firstName !== defaultFirstName) {
            onChange(newEvent);
          }
          if (defaultLastName !== lastName) {
            onChange(newEvent);
          }
        }
        if (inputName === "email") {
          if (defaultEmail !== email) {
            onChange(newEvent);
          }
        }
        if (inputName === "password") {
          handleChangePassword(newEvent);
        }
      }
    );
  };
  onCloseSection = () => {
    location.reload(true);
  };
  getTitle = () => {
    const { inputName } = this.props;
    let title;
    switch (inputName) {
      case "name":
        title = "Change Your Name";
        break;
      case "email":
        title = "Change E-Mail Address";
        break;
      case "mobileNumber":
        title = "Change Mobile Number";
        break;
      case "password":
        title = "Change Password";
        break;
      default:
        title = "Edit Profile";
        break;
    }
    return title;
  };
  handleSubmit = e => {
    e.preventDefault();
    const {
      handleSubmit,
      onClose,
      formErrors,
      inputName,
      handleSubmitPassword
    } = this.props;
    const { confirmPassword, newPassword, currentPassword } = this.state;
    if (inputName === "name") {
      handleSubmit(e);
      if (!formErrors.firstName && !formErrors.lastName) {
        onClose();
      }
    }
    if (inputName === "email") {
      handleSubmit(e);
      if (!formErrors.email) {
        onClose();
      }
    }
    if (inputName === "mobileNumber") {
      handleSubmit(e);
      if (!formErrors.mobileNumber) {
        onClose();
      }
    }
    if (inputName === "password") {
      handleSubmitPassword(e);
      if (
        newPassword &&
        currentPassword &&
        confirmPassword &&
        !formErrors.confirmPassword &&
        !formErrors.currentPassword &&
        !formErrors.newPassword
      ) {
        onClose();
      }
    }
  };
  getButtonStatus = () => {
    const { inputName, formErrors } = this.props;
    const {
      firstName,
      lastName,
      email,
      mobileNumber,
      currentPassword,
      newPassword,
      confirmPassword
    } = this.state;
    let active = false;
    switch (inputName) {
      case "name":
        if (
          firstName &&
          lastName &&
          !formErrors["firstName"] &&
          !formErrors["lastName"]
        ) {
          active = true;
        }
        break;
      case "mobileNumber":
        if (mobileNumber && !formErrors["mobileNumber"]) {
          active = "true";
        }
        break;
      case "email":
        if (email && !formErrors["email"]) {
          active = true;
        }
        break;
      case "password":
        if (
          currentPassword &&
          newPassword &&
          confirmPassword &&
          !formErrors["currentPassword"] &&
          !formErrors["newPassword"] &&
          !formErrors["confirmPassword"]
        ) {
          active = true;
        }
        break;
    }
    return active;
  };
  render() {
    const {
      formErrors,
      submitPhoneNumber,
      showErrors,
      inputName,
      smsVerified,
      sendSmsVerificationKey,
      sendEmailVerificationKey,
      emailVerified,
      smsVerification,
      onSmsVerified,
      closeVerification
    } = this.props;
    const {
      firstName,
      lastName,
      email,
      mobileNumber,
      currentPassword,
      newPassword,
      confirmPassword
    } = this.state;
    const active = this.getButtonStatus();
    return (
      (smsVerification && (
        <SmsVerification
          mobileNumber={mobileNumber}
          onSmsVerified={onSmsVerified}
          closeVerification={closeVerification}
          sendSmsVerificationKey={sendSmsVerificationKey}
        />
      )) || (
        <div className="sign-page edit-profile bg-gray profile-desktop">
          {/* Header */}
          <div className="head-general with-back">
            <a href="javascript: void(0)" />
            <h4>{this.getTitle()}</h4>
            <a
              href="javascript: void(0)"
              onClick={() => this.onCloseSection()}
              className="close"
            >
              <i className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <div className="row">
            <div className="col-sm-6">
              <form onSubmit={this.handleSubmit}>
                <div className="white-bg">
                  {inputName === "name" && (
                    <React.Fragment>
                      <div
                        className={`form-group sticky-form-label ${(showErrors &&
                          formErrors &&
                          formErrors["firstName"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="firstName"
                          className={`form-input ${(firstName && "active") ||
                            ""}`}
                          defaultValue={firstName}
                          type="text"
                          autoCapitalize="none"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="firstName">Firstname</label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["firstName"] &&
                            formErrors["firstName"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group sticky-form-label  ${(showErrors &&
                          formErrors &&
                          formErrors["lastName"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="lastName"
                          className={`form-input ${(lastName && "active") ||
                            ""}`}
                          autoCapitalize="none"
                          defaultValue={lastName}
                          type="text"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="lastName">Lastname</label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["lastName"] &&
                            formErrors["lastName"]) ||
                            ""}
                        </span>
                      </div>
                    </React.Fragment>
                  )}
                  {inputName === "email" && (
                    <div
                      className={`form-group sticky-form-label  ${(showErrors &&
                        formErrors &&
                        formErrors["email"] &&
                        "error") ||
                        ""}`}
                    >
                      <div className="d-flex justify-content-around phone-div">
                        <input
                          id="email"
                          className={`form-input ${(email && "active") || ""}`}
                          autoCapitalize="none"
                          defaultValue={email}
                          type="text"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="email">E-Mail</label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["email"] &&
                            formErrors["email"]) ||
                            ""}
                        </span>
                        <a
                          href="javascript:void(0)"
                          className="verified-div d-flex align-items-center hide-xs"
                          onClick={e =>
                            (emailVerified && e.preventDefault()) ||
                            sendEmailVerificationKey()
                          }
                        >
                          {!emailVerified && (
                            <>
                              <label>Not Verified</label>
                              <i className="icon icon-arrow-left rotate" />
                            </>
                          )}
                        </a>
                        <a className="verified-div visible-xs">
                          {!emailVerified && (
                            <>
                              <label>Not Verified</label>
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                >
                                  <g fill="none" fillRule="evenodd">
                                    <circle
                                      cx="7.5"
                                      cy="7.5"
                                      r="7.5"
                                      fill="#D8D8D8"
                                    />
                                    <path
                                      fill="#FFF"
                                      fillRule="nonzero"
                                      d="M6.881 7.5L4.128 4.747a.438.438 0 0 1 .619-.619L7.5 6.881l2.753-2.753a.437.437 0 1 1 .619.619L8.119 7.5l2.753 2.753a.437.437 0 1 1-.619.619L7.5 8.119l-2.753 2.753a.437.437 0 1 1-.619-.619L6.881 7.5z"
                                    />
                                  </g>
                                </svg>
                              </span>
                            </>
                          )}
                        </a>
                      </div>
                      {!emailVerified && (
                        <a
                          href="javascript:void(0)"
                          className="visible-xs verified-button-abs"
                          onClick={e =>
                            (emailVerified && e.preventDefault()) ||
                            sendEmailVerificationKey()
                          }
                        >
                          Click here to verify your mail
                        </a>
                      )}
                    </div>
                  )}
                  {inputName === "mobileNumber" && (
                    <PhoneInput
                      smsVerified={smsVerified}
                      submitPhoneNumber={submitPhoneNumber}
                      defaultNumber={mobileNumber}
                      showErrors={showErrors}
                      className="sticky-form-label"
                      label="Mobile Number"
                      sendSmsVerificationKey={sendSmsVerificationKey}
                    />
                  )}
                  {inputName === "password" && (
                    <React.Fragment>
                      <div
                        className={`form-group sticky-form-label  ${(showErrors &&
                          formErrors &&
                          formErrors["currentPassword"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="currentPassword"
                          className={`form-input ${(currentPassword &&
                            "active") ||
                            ""}`}
                          autoCapitalize="none"
                          type="password"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="currentPassword">
                          Current Password
                        </label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["currentPassword"] &&
                            formErrors["currentPassword"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group sticky-form-label  ${(showErrors &&
                          newPassword &&
                          formErrors["newPassword"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="newPassword"
                          className={`form-input ${(newPassword && "active") ||
                            ""}`}
                          autoCapitalize="none"
                          type="password"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="newPassword">New Password</label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["newPassword"] &&
                            formErrors["newPassword"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group sticky-form-label  ${(showErrors &&
                          formErrors &&
                          formErrors["confirmPassword"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="confirmPassword"
                          className={`form-input ${(confirmPassword &&
                            "active") ||
                            ""}`}
                          autoCapitalize="none"
                          type="password"
                          onChange={e => this.handleChange(e)}
                        />
                        <label htmlFor="confirmPassword">
                          Confirm Password
                        </label>
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["confirmPassword"] &&
                            formErrors["confirmPassword"]) ||
                            ""}
                        </span>
                      </div>
                    </React.Fragment>
                  )}
                </div>
                <div className="use-buttons">
                  <button
                    className={`btn btn-sign register-button ${(active &&
                      "active") ||
                      ""}`}
                    type="submit"
                  >
                    <span>Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )
    );
  }
}
